<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    orgId: { type: String, required: true },
  },
});
</script>

<template>
  <div>FIXME</div>
  <!--  <div class="settings-page integration">
    <div class="title">
      <div>
        <GmailIcon />
        <h2>Gmail</h2>
      </div>
      <div class="actions">
        <BaseLink
          @click="
            openUrl('https://routine.co/integrations/services/gmail')
          "
        >
          <template #icon><ExternalIcon /></template>Help</BaseLink
        >
        <BaseButton
          kind="main"
          type="secondary"
          text="Refresh"
          @click="refresh()"
          ><template #icon><RefreshIcon /></template
        ></BaseButton>
      </div>
    </div>

    <p class="description">Turn starred emails into tasks.</p>

    <div class="introduction errorMsg" v-if="integrationError">
      <span class="">
        {{ integrationError.message }}
      </span>
    </div>

    <section>
      <div v-for="identity in gmailIdentities" :key="identity.identity">
        <div class="entry small">
          <div class="account">
            <img src="../../assets/apps/google.svg" />
            <label>{{ identity.identity }}</label>
          </div>

          <div class="actions">
            <RStatus :type="identity.status" v-if="identity.hasAccess" />

            <BaseButton
              v-if="
                (identity.hasSetup && integrationError) ||
                (identity.hasSetup && !identity.hasAccess)
              "
              kind="main"
              type="secondary"
              text="Retry to connect"
              @click="connect(identity)"
            />
            <BaseButton
              v-else-if="!identity.hasSetup && !identity.hasAccess"
              kind="main"
              type="secondary"
              text="Connect"
              @click="addIdentity(identity)"
            />
            <BaseButton
              v-if="identity.hasSetup"
              kind="main"
              type="secondary"
              text="Disable"
              @click="removeIdentity(identity)"
            />
            <BaseButton
              v-else-if="!identity.hasSetup && identity.hasAccess"
              kind="main"
              type="secondary"
              text="Enable"
              @click="addIdentity(identity)"
            />
          </div>
        </div>
      </div>
    </section>
  </div>-->
</template>

<!--
<script lang="ts">
import * as _ from "lodash-es";
import { computed, ComputedRef, defineComponent, watch } from "vue";
import { useRoute } from "vue-router";

import { Gmail } from "@ctrl/controller-rpc";

import BaseButton from "@/components/base/BaseButton.vue";
import BaseLink from "@/components/base/BaseLink.vue";
import { ConnectionStatusType } from "@/components/base/types";
import RStatus from "@/components/elements/RStatus.vue";
import GmailIcon from "@/components/icons/apps/google/GmailIcon.vue";
import ExternalIcon from "@/components/icons/ExternalIcon.vue";
import RefreshIcon from "@/components/icons/RefreshIcon.vue";
import * as inject from "@/components/inject";
import { useReleaser } from "@/ref";
import { RouteNames } from "@/routes/types";
import { navigateTo } from "@/utils/navigate";
import { openExternalUrl } from "@/utils/open-external-url";

type IdentityStatus = {
  identity: string;
  status: ConnectionStatusType;
  hasSetup: boolean;
  hasAccess: boolean | undefined;
};

export default defineComponent({
  components: {
    BaseButton,
    BaseLink,
    GmailIcon,
    ExternalIcon,
    RefreshIcon,
    RStatus,
  },
  async setup() {
    const controller = inject.controller();
    const router = inject.router();
    const route = useRoute();
    const openUrl = (url: string) => openExternalUrl(url, controller);
    const releaser = useReleaser();
    const [identities, gmail] = await (() => {
      const identities = releaser.add(controller.auth.profiles());
      const gmail = releaser.add(
        controller.integration
          .list()
          .then((list) =>
            list.map((integrations) =>
              Object.entries(integrations).find(
                (
                  integration
                ): integration is [string, Gmail & { type: "gmail" }] =>
                  integration[1].type === "gmail"
              )
            )
          )
      );
      return Promise.all([identities, gmail]);
    })();
    const isBetaTester = computed(
      () =>
        identities.value.find((p) =>
          p.userinfo.email.endsWith("@routine.co")
        ) !== undefined
    );
    const identifier = gmail.map((gmail) => (gmail ? gmail[0] : null));
    const integration = gmail.map((gmail) => (gmail ? gmail[1] : null));

    const integrationError: ComputedRef<{
      cause: string;
      message: string;
      details: string;
    } | null> = computed(() => {
      if (integration.value && "error" in integration.value.state) {
        return {
          message: integration.value.state.error,
          details: integration.value.state.details,
          cause: integration.value.state.errorType,
        };
      } else {
        return null;
      }
    });

    const isIntegrationLoading = computed(() => {
      if (!integration.value) {
        return false;
      }
      return integration.value.state.status === "initializing";
    });

    const gmailIdentities = computed(() => {
      return identities.value.map((profile) => {
        const hasSetup =
          (integration.value &&
            integration.value.config.filters.some(
              (entry) => entry[0] === profile.identity
            )) ||
          false;
        const status = !hasSetup
          ? ConnectionStatusType.inactive
          : integrationError.value
            ? ConnectionStatusType.error
            : isIntegrationLoading.value
              ? ConnectionStatusType.loading
              : ConnectionStatusType.active;
        return {
          identity: profile.identity,
          hasAccess: profile.scopes.gmail,
          hasSetup,
          status,
        };
      });
    });

    function connect(identity: IdentityStatus) {
      const profile = identities.value.find(
        (p) => p.identity === identity.identity
      );
      if (!profile) return;

      navigateTo(RouteNames.SettingsIntegrationsGmailConsent, router, {
        params: { id: identity.identity },
      });
    }

    function _addIntegration(identity: IdentityStatus) {
      if (identifier.value === null || integration.value === null) {
        controller.integration.add({
          filters: [[identity.identity, { selected_label: "STARRED" }]],
          type: "gmail",
        });
      } else {
        let config = _.clone(integration.value.config);
        config.filters.push([identity.identity, { selected_label: "STARRED" }]);

        controller.integration.update(identifier.value, {
          ...config,
          type: "gmail",
        });
      }
    }

    function _removeIntegration(identity: IdentityStatus) {
      if (!identifier.value || !integration.value) {
        window.console.error(
          "Trying to remove Gmail integration while it not setup"
        );
        return;
      }

      let config = _.clone(integration.value.config);
      config.filters = config.filters.filter(
        (entry) => entry[0] !== identity.identity
      );

      if (config.filters.length > 0) {
        controller.integration.update(identifier.value, {
          ...config,
          type: "gmail",
        });
      } else {
        controller.integration.remove(identifier.value);
      }
    }

    function addIdentity(identity: IdentityStatus) {
      if (!identity.hasAccess) {
        connect(identity);
        return;
      }

      if (!identity.hasSetup) {
        _addIntegration(identity);
      }
    }

    function removeIdentity(identity: IdentityStatus) {
      if (identity.hasSetup) {
        _removeIntegration(identity);
      }
    }

    function refresh() {
      if (identifier.value && integration.value)
        controller.integration.refresh(identifier.value);
    }

    // Auto-activation after authorization
    const new_account = computed(() => {
      return (route?.query["activate"] as string) || null;
    });

    const activateAccount = (account: string | null) => {
      if (!account) {
        return;
      }
      const identity = gmailIdentities.value.find(
        (val) => val.identity === account
      );
      if (!identity || !identity.hasAccess) {
        // eslint-disable-next-line no-console
        console.warn("Gmail: cannot auto-register given account", account);
        return;
      }

      addIdentity(identity);
    };

    watch(new_account, activateAccount, { immediate: true });
    if (new_account.value) {
      activateAccount(new_account.value);
    }

    // Context
    return {
      addIdentity,
      connect,
      gmailIdentities,
      integrationError,
      isBetaTester,
      isIntegrationLoading,
      openUrl,
      refresh,
      removeIdentity,
    };
  },
});
</script>

<style scoped lang="scss">
@use "../../styles/settings.scss";

.entry {
  .account {
    display: flex;
    column-gap: 8px;
  }

  .actions {
    column-gap: 16px;
  }
}
</style>
-->
